const FILTERS_TO_RESET = [
  "stars",
  "price",
  "query",
  "time",
  "airline",
  "cabinType",
  "type",
  "departureTime",
  "arrivalTime",
];

const FILTERS_TO_RESET_ON_APPLY = [{ key: "currentPage", value: 1 }];

export { FILTERS_TO_RESET, FILTERS_TO_RESET_ON_APPLY };
